import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLegalAcceptance } from "../context/LegalAcceptanceContext";

// servicePath: service root for multi-page services (defaults to the current URL).
export default function ServiceLegalRoute({ children, servicePath }) {
  const { t } = useTranslation();
  const location = useLocation();
  const path = servicePath || location.pathname;
  const { ensureServicePathAccepted, serviceCheckLoading, acceptedDocuments } =
    useLegalAcceptance();

  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkAccess = async () => {
      const isAllowed = await ensureServicePathAccepted(path);
      if (isMounted) {
        setAllowed(isAllowed);
      }
    };

    checkAccess();

    return () => {
      isMounted = false;
    };
  }, [ensureServicePathAccepted, path, acceptedDocuments]);

  if (serviceCheckLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(100vh - 170px)",
        }}
      >
        <Spin size="large" tip={t("serviceLegal.checkingAccess")} />
      </div>
    );
  }

  // The legal terms modal prompts for any unaccepted document; nothing to show here.
  if (!allowed) {
    return null;
  }

  return children;
}
